import React from 'react'

function GewinnspielListe() {
  return (
    <div>GewinnspielListe</div>
  )
}

export default GewinnspielListe